import React, { useRef, useState } from 'react';
import { Button, Flexbox, Icon, useOnClickOutside } from '@hiiretail/synergy-ui';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

type UserMenuProps = {
  title: string;
  onLogoutBtnClick: () => void;
};

export type UserMenuComponent = React.FC<UserMenuProps>;

const UserMenuWrapper = styled(Flexbox)`
  position: relative;
`;

const UserMenuContent = styled(Flexbox)`
  position: absolute;
  background-color: #f9fafb;
  color: black;
  padding-bottom: ${(props) => props.theme.spacing(2)}px;
  box-shadow: 0 3px 5px rgba(9, 30, 66, 0.2), 0 0 1px rgba(9, 30, 66, 0.31);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  width: 100%;
  height: max-content;
  z-index: 1000;
  top: 95%;
  min-width: 120px;
  right: 0;
`;

const MenuTrigger = styled(Button)`
  z-index: 1001;
  span {
    display: flex;
  }
`;

export const UserMenu: UserMenuComponent = ({ title, children, onLogoutBtnClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();

  const containerRef = useRef(null);
  useOnClickOutside(containerRef, () => setIsOpen(false));

  const handleProfileBtnClick = () => {
    setIsOpen(false);
    history.push('/profile');
  };

  const handleLogoutBtnClick = () => {
    setIsOpen(false);
    onLogoutBtnClick();
  };

  return (
    <UserMenuWrapper container ref={containerRef}>
      <MenuTrigger variant="secondary" onClick={() => setIsOpen((prevState) => !prevState)}>
        {title.length ? title : <Icon.Person size="sm" />}
      </MenuTrigger>
      {isOpen && (
        <UserMenuContent container direction="column">
          {children}
          <Flexbox item container>
            <Button fullWidth variant="secondary" onClick={handleProfileBtnClick}>
              Profile
            </Button>
          </Flexbox>
          <Flexbox item container>
            <Button fullWidth variant="secondary" onClick={handleLogoutBtnClick}>
              Logout
            </Button>
          </Flexbox>
        </UserMenuContent>
      )}
    </UserMenuWrapper>
  );
};
